import { css } from '@emotion/css';

export const videoContainerCss = css`
  display: block;
  height: 100%;
  position: relative;
  width: 100%;
`;

export const videoCss = css`
  width: 100%;
  height: 100%;
  display: block;
`;

const objectFitCoverCss = css`
  object-fit: cover;
`;

const objectFitContainCss = css`
  object-fit: contain;
`;

export const getObjectFit = (isBackgroundVideo?: boolean): string => {
  return isBackgroundVideo ? objectFitCoverCss : objectFitContainCss;
};
